import { render } from "./Layout.vue?vue&type=template&id=25084f1e&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=25084f1e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-25084f1e"

export default script